module.exports = __webpack_public_path__ + "img/Image3.69f1e39d.png";